// ./src/contexts/PartnerPackagesContext/PartnerPackagesContext.tsx
//
// Thin context wrapper around the usePartnerPackages hook. All derived data lives
// in the hook itself. See VolunteerRolesContext for the pattern.

import React, { createContext, useContext } from "react";

import { usePartnerPackages, UsePartnerPackagesOptions, UsePartnerPackagesReturn } from "@/hooks/usePartnerPackages";

const PartnerPackagesContext = createContext<UsePartnerPackagesReturn | null>(null);

export interface PartnerPackagesProviderProps extends UsePartnerPackagesOptions {
  children: React.ReactNode;
}

export const PartnerPackagesProvider: React.FC<PartnerPackagesProviderProps> = ({ children, ...options }) => {
  const value = usePartnerPackages(options);

  return <PartnerPackagesContext.Provider value={value}>{children}</PartnerPackagesContext.Provider>;
};

export const usePartnerPackagesContext = (): UsePartnerPackagesReturn => {
  const context = useContext(PartnerPackagesContext);

  if (!context) {
    throw new Error(
      "usePartnerPackagesContext must be used within a <PartnerPackagesProvider>. " +
        "Wrap your component tree with <PartnerPackagesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalPartnerPackagesContext = (): UsePartnerPackagesReturn | null => {
  return useContext(PartnerPackagesContext);
};
